import React from 'react';
import { Sparkle } from '@phosphor-icons/react';
import classNames from 'classnames';

interface Props {
  variant?: 'purple' | 'pink' | 'grey-outline';
  text: string | React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

const SellingPoint: React.FC<Props> = (props) => {
  const { variant, text, icon, className } = props;

  const containerClass = classNames({
    'w-full flex items-center flex-row p-3 sm:p-4 gap-2 sm:gap-4 rounded-md': true,
    'bg-gradient-purple-light text-white': !variant || variant === 'purple',
    'bg-gradient-primary-right text-white': variant === 'pink',
    'border border-grey-900 border-solid text-black':
      variant === 'grey-outline',
  });

  return (
    <div className={classNames(containerClass, className)}>
      {icon || <Sparkle weight="fill" size="1.5rem" />}

      <div className="w-[calc(100%_-_2rem)] sm:w-[calc(100%_-_2.5rem)]">
        {text}
      </div>
    </div>
  );
};

export default SellingPoint;
